import {
	fetchStorageLimitDataForProduct,
	fetchStorageLimitDataForProductWithTimestamp,
} from './fetch-storage-limit-data-for-product/index.tsx';

export const actions = {
	fetchStorageLimitDataForProduct,
	fetchStorageLimitDataForProductWithTimestamp,
} as const;
